import * as numeral from 'numeral';

export class CurrencyDisplayUtil {
    static toShortNumber(value: number, sigFigs?: number): string {
        if (sigFigs === undefined) {
            sigFigs = 2;
        }
        if ((Math.abs(value)) < Math.pow(10, sigFigs)) {
            return String(value.toFixed(2));
        }
        const r = Math.ceil(Math.log10(Math.abs(value) + 0.01)) % 3;
        const format = (r === 0 ? '0a' : r === 1 ? '0.00a' : '0.0a');
        // console.log(`r = ${r} | format = ${format}`);
        return numeral(value).format(format)
            .toUpperCase()
            .replace('K', 'k');
    }

    static currencyScaleSuffix(ccy: string) {
        // if (ccy === 'INR') {
        //     return 'B';
        // }
        return 'M';
    }

    static flagCodeForCurrency(ccy) {
        if (ccy === 'USD') {
            return 'us';
        }
        if (ccy === 'EUR') {
            return 'eu';
        }
        if (ccy === 'INR') {
            return 'in';
        }
        return null;
    }

    static stringToNumber(valueStr: string): number {
        return numeral(valueStr).value();
    }

    static isValidNumber(valueStr: string): boolean {
        return numeral.validate(valueStr, navigator.language);
    }
}
